module.exports = __webpack_public_path__ + "img/1.bdbdb10b.jpg";